export const ErrorHandleEnum = {
  UIT_REGULAR_DOWNLOAD_PAGE: 'UIT_REGULAR_DOWNLOAD_PAGE',
};
